import Layout from "./components/Layout/Layout";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Education from "./pages/Educations/Education";
import Projects from "./pages/Projects/Projects";
import Techstack from "./pages/Techstack/Techstack";
// import WorkExp from "./pages/workExp/WorkExp";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from "./context/ThemeContext";
import { useSidebar } from "./hooks/useSidebar";
// import Tada from "react-reveal/Tada";
import { JackInTheBox } from 'react-awesome-reveal';
import MobileNav from "./components/MobileNav/MobileNav";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [theme] = useTheme();
  const { isExpanded } = useSidebar();
  return (
    <>
      <div id={theme}>
        <ToastContainer />
        <MobileNav />
        <Layout />
        <div className={`container main-content-container ${isExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
          <About />
          <Education />
          <Techstack />
          <Projects />
          {/* <WorkExp /> */}
          <Contact />
        </div>
        <div className="footer">
          <JackInTheBox>
            <div className="footer-content">
              <h4 className="footer-text">Made With ❤️ by Anish &copy; 2025</h4>
              <p className="footer-subtitle">Anish Singhal - Full Stack Developer</p>
            </div>
          </JackInTheBox>
        </div>
      </div>
      <ScrollToTop
        smooth
        color="white"
        style={{ 
          backgroundColor: "var(--primary-color)", 
          borderRadius: "50%",
          boxShadow: "var(--shadow-lg)",
          border: "2px solid var(--primary-color)"
        }}
      />
    </>
  );
}

export default App;
